import { registerLayout, ViewType } from '@kunlun/dependencies';

export const installSmartCustomerService = () => {
  registerLayout(
    `
      <view type="TABLE">
        <element widget="SmartCsChat" slot="table" />
      </view>
    `,
    {
      viewType: ViewType.Table,
      model: 'deli.aries.trade.DeliAriesChatInteraction'
    }
  );
};

installSmartCustomerService();
